"use client";

import { useState } from "react";
import { Button } from "../../../../shadcn/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../../../../shadcn/ui/dialog";
import { FileText, Trash2 } from "lucide-react";

interface RestoreDraftModalProps {
  open: boolean;
  onContinue: () => void;
  onStartFresh: () => void;
}

export default function RestoreDraftModal({ open, onContinue, onStartFresh }: RestoreDraftModalProps) {
  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="sm:max-w-md" {...({} as any)}>
        <DialogHeader {...({} as any)}>
          <DialogTitle className="flex items-center gap-2" {...({} as any)}>
            <FileText className="h-5 w-5" />
            Continue where you left off?
          </DialogTitle>
          <DialogDescription {...({} as any)}>
            We found a draft of your play service. Would you like to continue editing or start fresh?
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 pt-4">
          <Button onClick={onContinue} size="lg" className="w-full gap-2" {...({} as any)}>
            <FileText className="h-4 w-4" />
            Continue Editing
          </Button>
          <Button onClick={onStartFresh} variant="outline" size="lg" className="w-full gap-2" {...({} as any)}>
            <Trash2 className="h-4 w-4" />
            Start Fresh
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
